<button
  nz-button
  nz-popover
  [nzShape]="shape"
  [nzPopoverPlacement]="placement"
  [nzPopoverContent]="content"
>
  <i class="fas fa-question-circle"></i>
</button>
